import { render, staticRenderFns } from "./SiteBanner2.vue?vue&type=template&id=151a35f0&scoped=true"
import script from "./SiteBanner2.vue?vue&type=script&lang=js"
export * from "./SiteBanner2.vue?vue&type=script&lang=js"
import style0 from "./SiteBanner2.vue?vue&type=style&index=0&id=151a35f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151a35f0",
  null
  
)

export default component.exports